import { BeekLogo, DeviceSizes, Link } from 'beek-design-system';
import Alphabet from 'src/components/AudioBooksSiteMap/Alphabet';
import AudioBookLinks from 'src/components/AudioBooksSiteMap/AudioBookLinks';
import styled from 'styled-components';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: GraphQL imports are bugged but functional. Ignored for now to make CircleCI happy.
import { Audio } from 'src/api/siteMap/siteMap.graphql';

const Container = styled.div`
  width: 100%;
  max-width: 57.25rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;

  @media ${DeviceSizes.mobileM} {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  @media ${DeviceSizes.laptop} {
    overflow-x: hidden;
    padding-left: 0rem;
    padding-right: 0rem;
  }
`;

const TitlePage = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 2.75rem;
`;

const LinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 1.5rem;
`;

const BeekLogoExtended = styled(BeekLogo)`
  margin-top: 2.5rem;
  margin-bottom: 5rem;
`;

type SiteMapProps = {
  slug: string;
  siteMapQueryData: Audio[];
};

const AudioBookSiteMap = (props: SiteMapProps): JSX.Element => {
  const { siteMapQueryData, slug } = props;
  return (
    <Container>
      <BeekLogoExtended />
      <TitlePage>
        <LinkContainer>
          <Link
            href="/html_sitemap/audiolibros_a.html"
            pointerEvent="none"
            hoverType="sitemap"
            type="sitemap"
            typographyType="headline4"
            textDecoration="none"
            colorVariant="beekBlue"
          >
            Audiolibros
          </Link>
        </LinkContainer>
        <LinkContainer>
          <Link
            href="/listas"
            type="none"
            hoverType="sitemap"
            pointerEvent="auto"
            textDecoration="none"
            typographyType="headline4"
            colorVariant="gray100"
          >
            Artículos
          </Link>
        </LinkContainer>
      </TitlePage>
      <Alphabet slug={slug} />
      <AudioBookLinks data={siteMapQueryData} slug={slug} />
    </Container>
  );
};
export default AudioBookSiteMap;
